// extracted by mini-css-extract-plugin
export default {"container":"PunchupBuyerSeatsWidget_container__91zI7"};